import Statistics from 'pages/private/statistics/Statistics';

const FinanceStatisticsTab = () => {
  return <Statistics />;
};

export default FinanceStatisticsTab;
